import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const ResidentAPI = {
  getResident: async (token, id) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/resident?id=${id}`,
      headers: { Authorization: token },
    });
  },
  getResidents: async (token, queryParams = {}) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/resident/extended-list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },

  /**
   * Obtiene listado de residentes con filtros en una hoja de cálculo.
   * @param {string} token Token de autenticación
   * @param {object} params Parámetros de búsqueda
   * @returns {Promise} Respuesta de la API.
   */
  downloadResidents: async (token, params = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/resident/report/download`,
      headers: { Authorization: token },
      params,
      responseType: "blob",
    });
  },
  getResidentsByName: async (token, fullName) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/resident/list${
        fullName ? `?fullName=${fullName}` : ""
      }`,
      headers: { Authorization: token },
    });
  },
  createResident: async (token, formValues) => {
    return axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/resident`,
      headers: { Authorization: token },
      data: formValues,
    });
  },
  updateResident: async (token, formValues) => {
    return axios({
      method: "PUT",
      url: `${BACKEND_ORIGIN}/api/resident`,
      headers: { Authorization: token },
      data: formValues,
    });
  },
};

export default ResidentAPI;
